import {
  ISignupRequest,
  ILoginRequest,
  IConfirmRequest,
  IForgotPassword,
  IResetPassword,
  IProviderLoginRequest,
  IConfirmResponse
} from "@interfaces/auth";
import api from "../api";

const login = (data: ILoginRequest) => {
  return api.post("/api/auth/login", data);
};

const logInWithProvider = (data: IProviderLoginRequest) => {
  return api.post("/api/auth/log-in-with-provider", data);
};

const signUp = (data: ISignupRequest) => {
  return api.post("/api/auth/sign-up", data);
};

const verifySession = () => {
  return api.get<IConfirmResponse>("/api/auth/verify-session");
};

const confirm = (data: IConfirmRequest) => {
  return api.post("/api/auth/confirm", data);
};

const forgotPassword = (data: IForgotPassword) => {
  return api.post("/api/auth/forgot-password", data);
};

const resetPassword = (data: IResetPassword) => {
  return api.post("/api/auth/reset-password", data);
};

const logout = () => {
  return api.post("/api/auth/logout");
};

export const auth = {
  logInWithProvider,
  login,
  signUp,
  confirm,
  forgotPassword,
  resetPassword,
  logout,
  verifySession,
};
